import {POST} from "@/utils/request/request";
import {CreateDepartmentURL, DeleteDepartmentURL, ListDepartmentURL, UpdateDepartmentURL} from "@/consts/consts";

export function CreateDepartment(data) {
  return POST(CreateDepartmentURL, data)
}

export function DeleteDepartment(data) {
  return POST(DeleteDepartmentURL, data)
}

export function UpdateDepartment(data) {
  return POST(UpdateDepartmentURL, data)
}

export function ListDepartment(data) {
  return POST(ListDepartmentURL, data)
}
